import fetchJSON from '@api/api_helper';

const { type, key } = BF.fx.brandfolder();
const url = () => `/api/v4/${type.toLowerCase()}s/${key}/collections?per=1000`;

// TODO create typed param object
export const get = (params = {}) => (
  fetchJSON(url(), { params })
    .then(({ data }) => data)
    .catch(async (response) => { throw (await response.json()); })
);
